import {Brand} from '@vio/core/src/brand/types'
import {getSearchHost} from '@vio/core/src/brand/utils'
import {stringifyUrlObject} from '@vio/core/src/utils/url'

const SEARCH_RESULTS_PATH = '/Hotel/Search'
export const PAYMENT_PAGE_PATH = '/checkout'
export const CONFIRMATION_PAGE_PATH = '/confirmation'

// Ensures that public url always has a trailling slash
export const publicUrl = '/'

export const getSearchResultsUrl = (brand: Brand) => {
  try {
    const host = getSearchHost({
      brand,
      appEnv: process.env.NEXT_PUBLIC_ENV
    })

    return new URL(SEARCH_RESULTS_PATH, host).href
  } catch {
    return ''
  }
}

/**
 * Builds an absolute Accommodation Page URL
 */
export const buildAccommodationUrl = (
  brand: Brand,
  hotelId: string,
  checkIn: string,
  checkOut: string,
  locale: string
) => {
  if (!hotelId || !brand || !locale) return undefined

  const basePath = `/Hotel/${hotelId}/${locale}`

  const allParams: Record<string, unknown> = {
    ...(checkIn && {checkIn}),
    ...(checkOut && {checkOut})
  }

  const queryString = stringifyUrlObject(allParams)
  const address = queryString ? `${basePath}?${queryString}` : basePath

  return new URL(address, getSearchResultsUrl(brand)).href
}

type QueryValue = string | null | undefined

/**
 * Builds an absolute search URL that opens the hotel. The app WebView only
 * intercepts /Hotel/Search, so this takes the user back to the app's own hotel page.
 */
export const buildSearchHotelUrl = (
  brand: Brand,
  {
    hotelId,
    checkIn,
    checkOut,
    rooms
  }: {
    hotelId: QueryValue
    checkIn: QueryValue
    checkOut: QueryValue
    rooms: QueryValue
  }
) => {
  const searchResultsUrl = getSearchResultsUrl(brand)
  if (!hotelId || !searchResultsUrl) return undefined

  const queryString = stringifyUrlObject({
    hotelId,
    checkIn: checkIn || undefined,
    checkOut: checkOut || undefined,
    rooms: rooms || undefined,
    showHotelDetails: '1'
  })

  return `${searchResultsUrl}?${queryString}`
}
